import React, { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { FaAngleDown } from "react-icons/fa";
import NewTable from "../newTable/newTable";
import NewTableInventory from "../newTable/newTableInventory";

const SelectionCheckbox = React.memo(({ isSelected, onChange, id }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    onChange(e.target.checked);
  };
  
  return (
    <div className="w-max py-2 mt-1 pl-[0.52rem] h-full" onClick={(e) => {e.stopPropagation();}}>
      <input
        id={id}
        type="checkbox"
        checked={isSelected}
        onChange={handleClick}
        className="cursor-pointer"
      />
    </div>
  );
});

const PriceItemDetailAccordion = ({
  data,
  isExpanded,
  setIsExpanded,
  tableClassName,
  children,
  selectedItems,
  setSelectedItems,
  isScaled = false,
  filtered,
  setFiltered,
  id,
  isRap,
  isHeader = false,
  isModal = false,
  labelArray,
  sorting,
  setSorting,
  scrollRef,
  marketDiamondsLoading,
  setMarketDiamondsLoading,
  marketFilters,
  setAllSelected,
  allSelected
}) => {
  const [rowHeight, setRowHeight] = useState(52);

  const numberOfRows = 5;
  const accordionHeight = rowHeight ? rowHeight * numberOfRows + 64 : "auto";

  // const toggleExpansion = () => {
  //   setIsExpanded((prevExpanded) => !prevExpanded);
  // }
  // const [allSelected, setAllSelected] = useState(false);
  const [individualSelections, setIndividualSelections] = useState({});


   function handleSelectionChange(selectedRows) {
    if (id === "Inventory Diamonds") {
      if (allSelected) {
        setSelectedItems(selectedRows);
      } 
      else {
        setSelectedItems(selectedRows);

      }
    }
  }

  function handleAllSelect(isSelected) {
    setAllSelected(isSelected);
    handleSelectionChange(isSelected ? data : []);
  }
  return (
    <Accordion
      elevation={0}
      disableGutters
      className="m-0 border-l-0 border-r-0 border-b-0 border-t-[1px] border-[#ECECEC] border-solid "
      // defaultExpanded={isExpanded}
      expanded={isExpanded}
      key={id}
      onChange={() => setIsExpanded(!isExpanded)}
    >
     <div className="flex w-full">
        <div className="flex items-center w-max">
          {id === "Inventory Diamonds" && (
            <SelectionCheckbox
              isSelected={allSelected}
              onChange={handleAllSelect}
              id={id}
            />
          )}

          </div>
      <AccordionSummary
        expandIcon={<FaAngleDown />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        className="h-12 w-full min-h-[3rem] border-b-[1px] border-[#ECECEC] border-solid m-0 flex-row-reverse"
        style={{
          position: "sticky",
        }}
      >
        {children}
      </AccordionSummary>
     </div> 
      <AccordionDetails className="px-0 py-0">
        <div
          style={{
            height: isScaled && data.length > 5 ? accordionHeight : "",
            overflowY: isScaled ? "auto" : "hidden",
            //add height to the market diamonds table as it helps in making the render lag go away
          }}
          ref={scrollRef}
        >
          <NewTableInventory
            data={data}
            rowHeight={(height) => setRowHeight(height)}
            className={tableClassName}
            hideHeader={true}
            comparison={true}
            filtered={filtered}
            setFiltered={setFiltered}
            isRap={isRap}
            id={id}
            isModal={isModal}
            isHeader={isHeader}
            labelArray={labelArray}
            sorting={sorting}
            setSorting={setSorting}
            containerRef={scrollRef}
            marketDiamondsLoading={marketDiamondsLoading}
            setMarketDiamondsLoading={setMarketDiamondsLoading}
            marketFilters={marketFilters}
            onSelectionChange={handleSelectionChange}
            allSelected={allSelected}
            setAllSelected={setAllSelected}
            setSelectedItems={setSelectedItems}
            selectedItems={selectedItems}
          />
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default PriceItemDetailAccordion;
